import { Consumer } from '../Context'
import itshelpQr from '../assets/itshelp-qr.svg'

export default function NotAStudent() {
  return (
    <Consumer>
      {(props) => (
        <form>
          <div className="form-group" style={{ textAlign: 'center' }}>
            {/* Deliberately plain text, not links. This is a shared walk-in kiosk:
                anything clickable is a way for a student to navigate the device
                away from the check-in app and leave it sitting on another page for
                the next person. The address and number are still shown so they
                know where to go - they just write them down or use their phone. */}
            <span>
              The Academic Technologies Group only supports College of Osteopathic Medicine
              Students. If you need student support please contact ITSHelp at{' '}
              <strong>www.nyit.edu/itshelp</strong> or <strong>1-516-686-1188</strong>.
            </span>

            {/* Scanned with the student's own phone, so the site opens there and
                the kiosk stays on the check-in app. Generated at build time into
                src/assets by scripts/make-qr.mjs - not fetched from a QR service,
                which would be an external request on every render. */}
            <div className="qr">
              <img src={itshelpQr} alt="QR code linking to www.nyit.edu/itshelp" width="160" height="160" />
              <small>Scan with your phone to open the ITSHelp site</small>
            </div>
          </div>
          <br />
          <button type="button" onClick={props.resetForm} className="d-flex btn btn-primary ml-auto px-5">
            Okay
          </button>
        </form>
      )}
    </Consumer>
  )
}
